import React from "react";
import PropTypes from "prop-types";
import SelectedElement from "./selected-element";
import withStyles from "components/with-styles";
import styles from "./styles/selected-element-collection.css.js";

const SelectedElementCollection = ({ classes, selected, elements, getValueFromElement, getLabelFromElement }) => {
  return (
    <div className={classes.chips}>
      {Array.isArray(selected) ? (
        selected?.map(sel => (
          <SelectedElement
            key={sel}
            elements={elements}
            value={sel}
            getValueFromElement={getValueFromElement}
            getLabelFromElement={getLabelFromElement}
          />
        ))
      ) : (
        <SelectedElement
          key={selected}
          elements={elements}
          value={selected}
          getValueFromElement={getValueFromElement}
          getLabelFromElement={getLabelFromElement}
        />
      )}
    </div>
  );
};

SelectedElementCollection.propTypes = {
  /**
   * Elementos actualmente seleccionados
   */
  selected: PropTypes.array,
  /**
   * Valor actual del selector
   */
  value: PropTypes.array,
  /**
   * Función que obtiene el valor de la opción a partir de un elemento
   */
  getValueFromElement: PropTypes.func.isRequired,
  /**
   * Función que obtiene el valor de la etiqueta a partir de un elemento
   */
  getLabelFromElement: PropTypes.func.isRequired,
  /**
   * Colección de elementos del selector
   */
  elements: PropTypes.array.isRequired,
};

export default withStyles(styles)(SelectedElementCollection);
